<div
  class="custom-header flex flex-row items-center"
  [tp]="templateAddRow"
  [tpIsEnabled]="isExplorer === false"
>
  <button
    data-cy="metricsAddRowButton"
    class="hover:bg-m0 border-s400 text-s500 ml-[12px] rounded border px-2 py-[4px] font-normal focus:outline-none"
    [ngClass]="{
      'cursor-default': isExplorer === false
    }"
    type="button"
    (click)="addRow()"
    [disabled]="isExplorer === false"
  >
    <m-add-icon></m-add-icon>
  </button>

  <ng-template #templateAddRow>
    <div *ngIf="isExplorer === false">Explorer role required</div>
  </ng-template>
</div>

<div *ngIf="isExplorer$ | async"></div>
<div *ngIf="alias$ | async"></div>
